import { z } from "zod";

/**
 * F22 LINE Webhook 受信ログ (API-122)。
 * LINE Messaging API からの Webhook イベント (follow / unfollow / message / postback / accountLink 等)
 * を 1 イベント = 1 行として記録する。送信ログ (notifications / line_push) とは別系統。
 */
export const LineWebhookEventType = z.enum([
  "follow",
  "unfollow",
  "message",
  "postback",
  "accountLink",
  "other",
]);

export const LineWebhookLogStatus = z.enum(["success", "failed"]);

export const LineWebhookLog = z
  .object({
    received_at: z.iso.datetime({ offset: true }),
    event_type: LineWebhookEventType,
    status: LineWebhookLogStatus,
    error: z.string().nullable(),
  })
  .strict();

export const ListLineWebhookLogsInput = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: z.string().optional(),
  event_type: LineWebhookEventType.optional(),
  status: LineWebhookLogStatus.optional(),
});

export type LineWebhookEventTypeDto = z.infer<typeof LineWebhookEventType>;
export type LineWebhookLogStatusDto = z.infer<typeof LineWebhookLogStatus>;
export type LineWebhookLogDto = z.infer<typeof LineWebhookLog>;
export type ListLineWebhookLogsInputDto = z.infer<typeof ListLineWebhookLogsInput>;
